// extracted by mini-css-extract-plugin
module.exports = {"modal_wrap":"styles_modal_wrap__3XCPH","close":"styles_close__6RXZo"};